export enum REPORT_CAUSE_PERMISSIONS {
  REPORT_CAUSE_VIEW = 'REPORT_CAUSE_VIEW',
  REPORT_CAUSE_WRITE = 'REPORT_CAUSE_WRITE',
}
